import { Component, h, Prop, State, forceUpdate, Listen, Event, EventEmitter } from '@stencil/core';
import { overrideSettings } from "../../utils/utils";
import { v4 as uuidv4 } from 'uuid';

@Component({
  tag: 'fdi-multi-input',
  styleUrl: 'fdi-multi-input.scss',
  shadow: true,
})
export class FdiMultiInput {
  @Prop() __inputs: any = '[]'; // similar to the prop for fdi-text-input but an array
  @Prop() __settings: any;

  @State() inputs: Map<string, any>;
  @State() settings: any = {
    inputSettings: {},
    containerStyle: {},
    containerClass: 'fdi wc multi-input-container',
    inputContainerStyle: {},
    inputContainerClass: 'input-container',
    buttonContainerStyle: {},
    buttonContainerClass: 'button-container',
    deleteButtonStyle: {},
    deleteButtonClass: 'delete-button',
    addButtonStyle: {},
    addButtonClass: 'add-button',
    meta: {},
  };

  @Event({
    eventName: 'fdi_wc_multi-input_change',
    bubbles: true,
    cancelable: true,
  }) multiInputChanged: EventEmitter

  @Listen('fdi_wc_input_change')
  fdi_wc_input_change__handler( ev ){
    const { newValue, meta: { key } } = ev.detail;
    const existingInput = this.inputs.get(key);
    if (existingInput) {
      this.inputs.set(key, {
        ...existingInput,
        __value: newValue
      });
    }

    this.emitValue();
  }

  emitValue() {
    const values: string[] = [];
    this.inputs.forEach(({ __value }) => {
      values.push(__value);
    });

    this.multiInputChanged.emit({
      newValue: values,
      meta: this.settings.meta,
    });
  }

  removeInput( key ) {
    this.inputs.delete( key );
    this.emitValue();
    forceUpdate( this );
  }

  addInput(value = '') {
    const key = uuidv4();
    this.inputs.set( key, {
      style: { flexGrow: 1, display: 'flex' },
      __settings: {
        ...this.settings.inputSettings,
        meta: {
          ...this.settings.inputSettings.meta,
          key // Key used in our input handler
        }
      },
      __value: value
    });
    forceUpdate( this );
  }

  async componentWillLoad() {
    // Parse settings
    if (this.__settings) {
      let settings = this.__settings;
      if ( typeof settings === 'string' ){
        settings = JSON.parse( settings );
      }

      this.settings = overrideSettings( this.settings, settings );
    }

    // Parse list of input strings and create input elements
    if ( this.__inputs ){
      this.inputs = new Map();
      let inputs = this.__inputs;
      if ( typeof inputs === 'string' ){
        inputs = JSON.parse( inputs );
      }
      
      (inputs as any[]).forEach(input => {
        this.addInput(input);
      });
    }
  }

  render() {
    const {
      containerClass,
      containerStyle,
      inputContainerClass,
      inputContainerStyle,
      buttonContainerClass,
      buttonContainerStyle,
      deleteButtonClass,
      deleteButtonStyle,
      addButtonClass,
      addButtonStyle
    } = this.settings;

    return (
      <div class={containerClass} style={containerStyle}>
        {[...this.inputs.entries()].map( ([key, input]) => {
          return (
            <div class={inputContainerClass} style={inputContainerStyle}>
              <fdi-text-input id={key} {...input}></fdi-text-input>
              <div class={buttonContainerClass} style={buttonContainerStyle}>
                <button onClick={ () => this.removeInput( key ) } class={deleteButtonClass} style={deleteButtonStyle}>Delete</button>
              </div>
            </div>
          );
        })}
        <button onClick={ () => this.addInput() } class={addButtonClass} style={addButtonStyle}>Add</button>
      </div>
    );
  }
}
